import { render, staticRenderFns } from "./ExportLocal.vue?vue&type=template&id=063dc4ca&scoped=true&"
import script from "./ExportLocal.vue?vue&type=script&lang=js&"
export * from "./ExportLocal.vue?vue&type=script&lang=js&"
import style0 from "./ExportLocal.vue?vue&type=style&index=0&id=063dc4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063dc4ca",
  null
  
)

export default component.exports